export const CLOSE_MENU = "CLOSE_MENU";
export const TOGGLE_MENU = "TOGGLE_MENU";
export const SET_USER_INFO = "SET_USER_INFO";
export const LOGOUT = "LOGOUT";
export const SETHEADERHEIGHT = "SETHEADERHEIGHT";
export const SET_STAFF_INFO = "SET_STAFF_INFO";

export const closeMenu = () => ({
  type: CLOSE_MENU
});

export const toggleMenu = () => ({
  type: TOGGLE_MENU
});

export const setUserInfoAction = data => ({
  type: SET_USER_INFO,
  ...data
});

export const logout = () => ({
  type: LOGOUT
});

export const setHeaderHeight = val => ({
  type: SETHEADERHEIGHT,
  val: val
});
export const setStaffInfoAction = data => ({
  type: SET_STAFF_INFO,
  val: data
});
